let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j4YVf")).then(() => parcelRequire('armaY'));